import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap';
import { ensureXsrfToken } from './apis/core/xsrf';
import quill from './plugins/quill';

// 啟動時確保 xsrf-token cookie 存在；axios 的 baseURL / withCredentials / xsrf /
// 統一錯誤處理已移至 src/apis 的各 Request 實例。
ensureXsrfToken();

const app = createApp(App);
app.use(quill);
app.mount('#newHexRPG_Teachable');
